<template>
  <div
    v-if="showDisclaimer"
    class="disclaimer"
    :style="{
      maxWidth: maxWidth
    }"
  >
    <strong>Disclaimer:</strong>
    Please search for a food as specifically as you can. For example: ‘Plain Greek Yogurt > Yogurt.’
    We have thousands of foods to filter for you, so this will help you find what you’re looking
    for quicker!
  </div>
</template>

<script>
export default {
  props: {
    maxWidth: {
      type: String,
      default: 'none',
    },
    showDisclaimer: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
	.disclaimer {
        border:2px solid #5f9f3b;
        border-radius:6px;
        margin:10px auto;
        padding:24px;
    }
</style>
